<template>
  <div class="card card-content">
    <div class="card-header">
      <div class="header">
        <div class="breadcrumb">
          <a class="breadcrumb-item" v-link="{ path: '/'}">Accueil</a>
          <a class="breadcrumb-item" v-link="{ path: '/contact/list'}">Gestion des participants</a>
          <a class="breadcrumb-item" v-link="{ name: 'editContact', params: { contactId: this.contact.id } }">{{ name }}</a>
          <a class="breadcrumb-item" v-link="{ name: 'editContact.capes', params: { contactId: this.contact.id } }">CAPE</a>
        </div>
        <h1>{{ contact.leader_firstname }} {{ contact.leader_lastname }}</h1>
      </div>
      <div class="actions">
        <a class="btn btn-link" v-link="{ path: '/contact/list' }">Voir tous les participants</a>
        <a class="btn btn-link" v-link="{ name: 'addProjectWithContact', params: { contactId: contact.id } }">Ajouter un parcours</a>
        <a class="btn btn-link" v-link="{ name: 'addMeetingWithContact', params: { contactId: contact.id } }">Ajouter un rdv</a>
      </div>
    </div>
    <div class="card-block">
      <ul class="nav nav-tabs">
        <li class="nav-item">
          <a class="nav-link" v-link="{ name: 'editContact', params: { contactId: contact.id }}">Informations</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" v-link="{ name: 'parcoursContact', params: { contactId: contact.id }}">Parcours</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" v-link="{ name: 'planningContact', params: { contactId: contact.id }}">Planning</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" v-link="{ name: 'editContact.entreprises', params: { contactId: contact.id }}">Entreprises</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" v-link="{ name: 'editContact.emplois', params: { contactId: contact.id }}">Emplois</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" v-link="{ name: 'editContact.formations', params: { contactId: contact.id }}">Formations</a>
        </li>
        <li class="nav-item">
          <a class="nav-link active" v-link="{ name: 'editContact.capes', params: { contactId: contact.id }}">CAPE</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" v-link="{ name: 'editContact.cers', params: { contactId: contact.id }}">CER</a>
        </li>
      </ul>
    </div>
    <div class="card-block">
      <h2 class="card-title">Liste des CAPE</h2>
      <table class="table table-hover">
        <thead>
        <tr>
          <th>Titre</th>
          <th>&nbsp;</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="cape of capes | orderBy 'title'">
          <td>No : {{ cape.contract_num }} {{ cape.title }} - Début : {{ cape.start_date }} - Fin : {{ cape.end_date }}</td>
          <td class="text-xs-right">
            <button class="btn btn-primary" v-on:click="edit(cape)">Modifier</button>
            <button class="btn btn-warning" v-on:click="remove(cape)">Supprimer</button>
          </td>
        </tr>
        </tbody>
        <tfoot>
        <tr>
          <td colspan="6">
            <button class="btn btn-primary" v-on:click="create()">Créer un CAPE</button>
          </td>
        </tr>
        </tfoot>
      </table>
    </div>
  </div>
  <div class="card-block" v-if="cape !== null">
    <hr>
    <h2 class="card-title">{{ editionName }}</h2>
    <validator name="validator">
      <form novalidate>
        <div class="row form-group">
          <div class="col-sm-6">
              <switch :value.sync = "cape.incubator_adhesion" >Adhésion club couveuse</switch>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-6">
          <!-- Numéro contrat -->
           <div class="form-group">
            <label for="contract_num">Numéro de contrat</label>
            <input class="form-control"
              id                         = "contract_num"
              type                       = "text"
              v-model                    = "cape.contract_num"
             >
           </div>
          </div>   
                <div class="col-sm-6">
                  <!-- Libellé du contrat -->
                  <div class="form-group">
                      <label for="incubator_ca">Libellé du contrat</label>
                      <input class="form-control"
                             id                         = "title"
                             type                       = "text"
                             v-model                    = "cape.title"
                             v-validate:leader_lastname = ""
                             v-uppercase                = ""
                      >
                  </div>
                </div> 
                <div class="col-sm-6">
                  <!-- Date entree -->
                  <div class="form-group">
                      <label for="start_date">Date début de CAPE</label>
                      <!--
                      <date-picker
                              :time.sync = "cape.start_date"
                              :option    = "datepickerOptions"
                              :inputClass = "form-control"
                      ></date-picker>
                      -->
                      <input
                        id               = "start_date"
                        class            = "form-control"
                        type             = "text"
                        v-model          = "cape.start_date"
                      >
                      <!--<small class="form-text text-danger" v-if="$validator.start_date.required">Vous devez indiquer une date</small>-->
                  </div>
                </div>
                <div class="col-sm-6">
                  <!-- Date dossier -->
                  <div class="form-group">
                      <label for="end_date">Date fin de CAPE</label>
                      <!--
                      <date-picker
                              :time.sync = "cape.end_date"
                              :option    = "datepickerOptions"
                              :inputClass = "form-control"
                      ></date-picker>
                      -->
                      <input
                        id               = "end_date"
                        class            = "form-control"
                        type             = "text"
                        v-model          = "cape.end_date"
                      >
                      <!--<small class="form-text text-danger" v-if="$validator.end_date.required">Vous devez indiquer une date</small>-->
                  </div>
                </div>
                                                                             
                                          
                <div class="col-sm-6">
                  <!-- CA couveuse -->
                  <div class="form-group">
                      <label for="incubator_ca">CA en couveuse</label>
                      <input class="form-control"
                             id                         = "incubator_ca"
                             type                       = "text"
                             v-model                    = "cape.incubator_ca"
                      >
                  </div>
                </div>   
  
                <div class="col-sm-6">
                  <!-- Rétribution en couveuse -->
                  <div class="form-group">
                      <label for="incubator_retribution">Rétribution en couveuse</label>
                      <input class="form-control"
                             id                         = "incubator_retribution"
                             type                       = "text"
                             v-model                    = "cape.incubator_retribution"
                      >
                  </div>
                </div>   
                                      
                <div class="col-sm-12">
                  <!-- Incubator Reward -->
                  <div class="form-group">
                    <label for="sector">Motif de fin de CAPE</label>
                    <select id="sector" name="incubator_reward_id" v-model="cape.incubator_reward_id" class="form-control">
                    <option value=""></option>
                    <option v-for="incubatorReward in incubatorRewards" :value="incubatorReward.id">{{ incubatorReward.name }}</option>
                    </select>
                  </div>
                </div>           
        <div class="col-sm-12">
          <label for="observations">Observations</label>
          <textarea class="form-control" rows="6" cols="40" id="fs_observations" v-model="cape.observations"></textarea>
        </div>
          <div class="text-xs-right">
            <button class="btn btn-default" v-on:click.prevent="cancel()">Fermer</button>
            <button class="btn btn-primary" v-on:click.prevent="save()" :class="{ disabled: !$validator.valid }">Enregistrer</button>
          </div>
        </div>
      </form>
    </validator>
  </div>
</template>
<script>
    // Required for datepicker
    import moment from 'moment'

    // Options for datepicker
    import { datepickerOptions } from 'src/options/date'

    // Required for datepicker
    import datePicker from 'vue-datepicker/vue-datepicker-1.vue'
    import { Switch } from 'mint-ui'

    // Vuex
    import { getCapes, addCape, editCape, deleteCape } from 'src/vuex/actions/capeActions'
    import { getContact } from 'src/vuex/actions/contactActions'
    import {
        contact,
        incubatorRewards,
        cape,
        capes
        // capeRequestError as requestError
    } from 'src/vuex/getters'
    
    import { getIncubatorRewards } from 'src/vuex/actions/incubatorRewardsActions'

    export default{
      vuex: {
        getters: {
          cape,
          capes,
          // requestError,
          incubatorRewards,
          contact
        },
        actions: {
          getContact,
          getIncubatorRewards,
          getCapes,
          addCape,
          editCape,
          deleteCape
        }
      },
      validators: {
        // list: function (val) {
        //  return /^[1-9]+$/.test(val)
        // }
      },
      data () {
        return {
          isHidden: true,
          cape: null,
          capeUpdate: null,
          datepickerOptions
        }
      },
      computed: {
        name: function () {
          if (Number.isInteger(this.contact.id)) {
            return this.contact.leader_firstname + ' ' + this.contact.leader_lastname
          } else {
            return 'Contact'
          }
        },
        editionName: function () {
          return (this.cape !== null && Number.isInteger(this.cape.id)) ? 'Edition' : 'Création'
        }
      },
      methods: {
        edit: function (cape) {
          this.cape = JSON.parse(JSON.stringify(cape))
          this.capeUpdate = cape
        },
        remove: function (cape) {
          this.deleteCape(cape)
          let that = this
          setTimeout(function () { that.cape = null }, 1000)
        },
        create: function () {
          this.cape = {}
          this.capeUpdate = null
        },
        cancel: function () {
          this.cape = null
          this.capeUpdate = null
        },
        save: function () {
          if (this.cape !== null) {
            if (typeof (this.cape.start_date) === 'undefined' || this.cape.start_date === null || this.cape.start_date === '' || this.cape.start_date === 'undefined' || this.cape.start_date === 'Invalid date') {
              this.cape.start_date = ''
            } else {
              this.cape.start_date = moment(this.cape.start_date, 'DD/MM/YYYY').format('DD-MM-YYYY')
            }
            if (typeof (this.cape.end_date) === 'undefined' || this.cape.end_date === null || this.cape.end_date === '' || this.cape.end_date === 'undefined' || this.cape.end_date === 'Invalid date') {
              this.cape.end_date = ''
            } else {
              this.cape.end_date = moment(this.cape.end_date, 'DD/MM/YYYY').format('DD-MM-YYYY')
            }
            if (Number.isInteger(this.cape.id) === true) {
              this.editCape(this.capeUpdate, this.cape)
            } else {
              this.cape.contact_id = this.contact.id
              console.log('saveCape ' + this.cape.start_date)
              this.addCape(this.cape)
            }

            if (this.error === false) {
              this.cape = null
            }

            let contactId = this.contact.id
            let that = this
            setTimeout(function () { that.cape = null; that.getCapes(contactId) }, 1000)
          }
        }
      },
      components: { 'date-picker': datePicker, Switch },
      ready () {
        // let vm = this
        this.$dispatch('preview-data', [])
        this.getContact(this.$route.params.contactId)
        this.getCapes(this.$route.params.contactId)
        // .then foreach if (vm.contact.start_date === 'Invalid date') {
        this.getIncubatorRewards()
      }
    }
</script>



// WEBPACK FOOTER //
// ContactEditCapes.vue?237ea330